const requireRouter = require.context('.', false, /^(?!\.\/index).*\.js$/)
let routers = [{
  path: '/setting/index',
  component: () => import('@/views/feiche/index'),
  name: 'setting-index',
  meta: {
    title: ''
  }
}]

requireRouter.keys().forEach(fileName => {
  routers = [...routers, ...requireRouter(fileName).default]
})

export default routers



// WEBPACK FOOTER //
// ./src/router/setting/index.js